/**
 * Take the browser's download and save menus off the media of a page.
 *
 * A deterrent, not protection: what a person can see or hear they can
 * still capture. It removes the easy paths: the "Download" entry of the
 * native audio and video players, picture-in-picture and remote playback,
 * the right-click "Save as", and dragging a picture out of the page.
 *
 * Returns the function that puts things back.
 */
const MEDIA = "img, video, audio, canvas";

const lock = (el: Element) => {
  if (el instanceof HTMLMediaElement) {
    el.setAttribute("controlsList", "nodownload noremoteplayback");
    el.setAttribute("disablePictureInPicture", "");
  }
  if (el instanceof HTMLImageElement) el.draggable = false;
};

export function guardMediaDownloads(root: HTMLElement | Document = document): () => void {
  const scope = root instanceof Document ? root.body : root;
  const stop = (e: Event) => {
    const target = e.target as Element | null;
    if (target?.closest?.(MEDIA)) e.preventDefault();
  };
  scope.querySelectorAll(MEDIA).forEach(lock);
  const watcher = new MutationObserver((changes) => {
    for (const change of changes) {
      change.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches(MEDIA)) lock(node);
        node.querySelectorAll(MEDIA).forEach(lock);
      });
    }
  });
  watcher.observe(scope, { childList: true, subtree: true });
  scope.addEventListener("contextmenu", stop, true);
  scope.addEventListener("dragstart", stop, true);
  return () => {
    watcher.disconnect();
    scope.removeEventListener("contextmenu", stop, true);
    scope.removeEventListener("dragstart", stop, true);
  };
}
